import { useEditEventMutation } from '@app/data/editEvent/api'
import { logger } from "@app/data/logger/logger";


export default function useEditEvent() {
	const [editEvent, {isLoading, isSuccess}] = useEditEventMutation();

	const build = async (eventData) => {
		try {
      await editEvent(eventData)
		} catch (err) {
      if (process.env.NODE_ENV === 'development') {
        logger.error(`Error while editing event - ${err.message}`)
      }
		}
	}

	return {build, isLoading, isSuccess}
}